import { SbSharedRefineMenuFilterMetal } from './SbSharedRefineMenuFilterMetal';
import { SbSharedRefineMenuFilterStyle } from './SbSharedRefineMenuFilterStyle';
import { SbSharedRefineMenuFilterColor } from './SbSharedRefineMenuFilterColor';
import { SbSharedRefineMenuFilterStone } from './SbSharedRefineMenuFilterStone';
import { SbSharedRefineMenuFilterPeriod } from './SbSharedRefineMenuFilterPeriod';
import { SbSharedRefineMenuFilterOrigin } from './SbSharedRefineMenuFilterOrigin';
import { SbSharedRefineMenuFilterCreator } from './SbSharedRefineMenuFilterCreator';
import { SbSharedRefineMenuFilterMaterial } from './SbSharedRefineMenuFilterMaterial';
import { SbSharedRefineMenuFilterItemType } from './SbSharedRefineMenuFilterItemType';
import { SbSharedRefineMenuFilterAvailability } from './SbSharedRefineMenuFilterAvailability';
import { SbSharedRefineMenuFilterMatchingSets } from './SbSharedRefineMenuFilterMatchingSets';

/* eslint-disable camelcase */

export const sbSharedRefineMenuFiltersMap = {
    color: {
        component: SbSharedRefineMenuFilterColor,
    },
    creator: {
        component: SbSharedRefineMenuFilterCreator,
    },
    item_type: {
        component: SbSharedRefineMenuFilterItemType,
    },
    lead_time_bucket: {
        component: SbSharedRefineMenuFilterAvailability,
    },
    matchingSets: {
        component: SbSharedRefineMenuFilterMatchingSets,
    },
    material: {
        component: SbSharedRefineMenuFilterMaterial,
    },
    metal: {
        component: SbSharedRefineMenuFilterMetal,
    },
    origin: {
        component: SbSharedRefineMenuFilterOrigin,
    },
    period: {
        component: SbSharedRefineMenuFilterPeriod,
    },
    stone: {
        component: SbSharedRefineMenuFilterStone,
    },
    style: {
        component: SbSharedRefineMenuFilterStyle,
    },

    /**
     * Pass in empty objects to indicate that the filter can appear in applied filters, but it won't be
     * shown in the refine menu filter list.
     */
    refineSearch: {},
    technique: {},
    'shipping-free': {
        isBatchAppliedFilter: true,
    },
    'max-white-glove-price': {},
    'white-glove-shipping': {
        isBatchAppliedFilter: true,
    },
};
